<template>
  <div class="material-memo">
    <div class="memo-title" v-text="memoTitle"></div>
    <ul class="memo-list">
      <li class="memo-item" v-for="(memo, index) in memoArr" :key="index">
        <span class="index" v-if="memoArr.length > 1 && memo">{{ index+1 }}） </span>
        <span class="memo-detail">{{ memo }}</span>
      </li>
    </ul>
    <ul class="invalid-file-list" v-if="materialInvalidFileList.length">
      <li class="invalid-file">请点击查看或下载以下文件：</li>
      <li class="invalid-file" v-for="(file, index) in materialInvalidFileList" :key="index" @click="previewFile(file)">
        <span class="index" v-if="materialInvalidFileList.length > 1">{{ index+1 }}）</span>
        <a>{{ file.file_name }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import uploadFileService from '../../services/upload-file-service';
import imageService from '../../services/image-service';


export default {
  name: 'material-memo',
  props: {
    memoContent: {
      type: String,
      required: true,
    },
    memoTitle: {
      type: String,
      default: '预审不合格',
    },
    invalidFileList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      memoArr: uploadFileService.makeStringList(this.memoContent),
    };
  },
  watch: {
    memoContent(newVal) {
      this.memoArr = uploadFileService.makeStringList(newVal);
    },
  },
  computed: {
    // 去重
    materialInvalidFileList() {
      const list = [];
      this.invalidFileList.forEach((file) => {
        const fileNameList = list.map(it => it.file_name);
        if (!fileNameList.includes(file.file_name)) {
          list.push(file);
        }
      });
      return list;
    },
  },
  methods: {
    previewFile(file) {
      if (!file || !file.url) return;
      if (imageService.isImage(file.url)) {
        this.$viewerApi({
          images: [file.url],
        });
      } else {
        window.open(file.url);
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/less/variable';
.material-memo {
  padding: 20px 20px 15px 20px;
  background-color: #fef7f8;
  font-size: 14px;
  color: @text-red;
  border-radius: 2px;
  border: 1px solid rgba(244,69,92,0.3);
  .memo-title {
    line-height: 14px;
    font-weight: bold;
  }
  .memo-list {
    margin-top: 8px;
  }
  .memo-item {
    display: flex;
    font-size: 14px;
    line-height: 24px;
    color: rgba(255, 90, 96, .8);
  }
  .index {
    margin-right: 4px;
  }
  .memo-detail {
    flex: 1;
    word-break: break-all;
  }
}
.invalid-file-list {
  margin-top: 8px;
  border-top: 1px dashed rgba(244,69,92,0.3);
  padding-top: 7px;
  color: #3FA2F5;
  .invalid-file {
    cursor: pointer;
    font-size: 14px;
    line-height: 24px;
    &:hover >a{
      text-decoration: underline;
    }
  }
  
}
</style>




// WEBPACK FOOTER //
// src/components/upload/memo.vue